import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar, Loader } from "@/components/ui";
import { useAuth } from "@/context/AuthContext";
import { labApi } from "@/data/api";

export default function AdminLabList() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [experiments, setExperiments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    labApi.adminList(token).then((r) => setExperiments(r.experiments || [])).catch(() => {}).finally(() => setLoading(false));
  }, [token]);

  return (
    <Screen>
      <TopBar title="Manage the Lab" subtitle="Experiments & landing page" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        <button data-testid="edit-landing-button" className="pressable" onClick={() => navigate("/admin/lab-landing")} style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14, padding: 14, marginBottom: 10, cursor: "pointer", textAlign: "left" }}>
          <Icon name="edit-2" size={18} color={colors.brand} />
          <span style={{ flex: 1, color: colors.onSurface, fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>Edit landing page</span>
          <Icon name="chevron-right" size={20} color={colors.muted} />
        </button>
        <button data-testid="new-lab-button" className="pressable" onClick={() => navigate("/admin/lab-edit")} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: colors.brand, color: colors.onBrand, border: "none", borderRadius: 12, padding: "13px", margin: "8px 0 18px", cursor: "pointer", fontSize: 14, fontWeight: 700, fontFamily: fonts.text }}>
          <Icon name="plus" size={16} color={colors.onBrand} />New experiment
        </button>
        {loading ? <Loader /> : experiments.map((e) => (
          <button key={e.id} data-testid={`lab-admin-row-${e.slug}`} className="pressable" onClick={() => navigate(`/admin/lab-edit?id=${e.id}`)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14, padding: 14, marginBottom: 10, cursor: "pointer", textAlign: "left" }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: colors.brandTertiary, display: "flex", alignItems: "center", justifyContent: "center", color: colors.onBrandTertiary, fontSize: 15, fontFamily: fonts.display, fontWeight: 800 }}>{e.number}</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: colors.onSurface, fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>{e.title}{e.published === false ? " (draft)" : ""}</div>
              <div style={{ color: colors.muted, fontSize: 12, marginTop: 2, fontFamily: fonts.text }}>{e.subtitle}</div>
            </div>
            <Icon name="chevron-right" size={20} color={colors.muted} />
          </button>
        ))}
      </div>
    </Screen>
  );
}
